var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBirthday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1410_13565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 4C8.74 4 9.33333 3.4 9.33333 2.66667C9.33333 2.41333 9.26667 2.18 9.14 1.98L8 0L6.86 1.98C6.73333 2.18 6.66667 2.41333 6.66667 2.66667C6.66667 3.4 7.26667 4 8 4ZM12 6H8.66667V4.66667H7.33333V6H4C2.89333 6 2 6.89333 2 8V14C2 14.3667 2.3 14.6667 2.66667 14.6667H13.3333C13.7 14.6667 14 14.3667 14 14V8C14 6.89333 13.1067 6 12 6ZM12.6667 13.3333H3.33333V11.3333C3.93333 11.3267 4.50667 11.0867 4.93333 10.66L5.66 9.94667L6.37333 10.66C7.24667 11.5333 8.76667 11.5267 9.63333 10.66L10.3533 9.94667L11.0667 10.66C11.4933 11.0867 12.0667 11.3267 12.6667 11.3333V13.3333ZM12.6667 10.3333C12.3267 10.3267 12.0067 10.2 11.7667 9.95333L10.3467 8.53333L8.92 9.95333C8.42667 10.4467 7.56667 10.4467 7.07333 9.95333L5.65333 8.53333L4.22667 9.95333C3.99333 10.1933 3.67333 10.3267 3.33333 10.3333V8C3.33333 7.63333 3.63333 7.33333 4 7.33333H12C12.3667 7.33333 12.6667 7.63333 12.6667 8V10.3333Z",
    fill: "#312E40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1410_13565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBirthday);
export default __webpack_public_path__ + "static/media/icon-birthday.66258c9551f5a78be967ee19fe3aa0d3.svg";
export { ForwardRef as ReactComponent };